module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Bezeichnung","supervisor":"Abteilungsleiter"},"en":{"title":"Title","supervisor":"Supervisor"}}')
  delete Component.options._Ctor
}
